import { resolveDefaultCycle } from "./offer";
import type { MemberCycleKey } from "./skus";

export const REGULAR_MEMBER_TABS = [
  { label: "月付", value: "month", discountInfo: "低至7.9折" },
  { label: "季付", value: "season", discountInfo: "低至7.4折" },
  { label: "年付", value: "year", discountInfo: "低至7.0折" },
  { label: "团队使用", value: "group", discountInfo: "最低6.5折" }
] as const;

export function resolveInitialCycle(timeMode: string | undefined): MemberCycleKey {
  return resolveDefaultCycle(timeMode);
}

/** 旧链接 tab=subscribe 仍落到月付。活动期不改写活动自己的 tab 值。 */
export function mapMemberQueryTab(tab: string | undefined, styled: boolean): string | undefined {
  if (!tab || styled) return tab;
  if (tab === "subscribe" || tab === "halfSubscribe" || tab === "month") return "month";
  if (tab === "year_v1") return "year";
  if (tab === "power") return "power";
  if (tab === "group" || tab === "team") return "group";
  return tab;
}

export function isMemberCycleTab(value: string): value is MemberCycleKey {
  return value === "month" || value === "season" || value === "year";
}

/** 卡片内部仍有按旧 time 枚举取天数的分支，月付订阅对应 subscribe。 */
export function toLegacyMemberTime(cycle: string): "subscribe" | "season" | "year" {
  if (cycle === "season" || cycle === "year") return cycle;
  return "subscribe";
}
